import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import routerConfig from '../../../config/router';
import {Button} from "../../../components/Button";

const Vendor = (props) => {
  return (
    <ul className="authentication__list">
      <li className="authentication__list-item">
        <Button
          name="My Inventory"
          onClick={() => {
            props.history.push(routerConfig.vendor.home);
          }}
        />
      </li>
      <li className="authentication__list-item">
        <Button
          name="Settings"
          onClick={() => {
            props.history.push(routerConfig.profile);
          }}
        />
      </li>
      <li className="authentication__list-item">
        <Button
          name="Log Out"
          onClick={() => {
            props.submitLogout();
          }}
        />
      </li>
    </ul>
  )
};
Vendor.propTypes = {
  submitLogout: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(Vendor);


// WEBPACK FOOTER //
// ./src/app/containers/Header/components/vendor.js